<template>
  <div class="relative w-full">
    <span
      class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
    >
      <i class="fas fa-search text-gray-400"></i>
    </span>
    <input
      v-model="localValue"
      @input="emitSearch"
      type="text"
      :placeholder="placeholder || 'Search...'"
      class="pl-10 pr-3 py-2 border rounded-lg w-full focus:ring-2 focus:ring-blue-500 outline-none transition-all dark:bg-dark-input dark:border-white/10 dark:text-white"
    />
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localValue: this.modelValue,
    };
  },
  methods: {
    emitSearch() {
      this.$emit("update:modelValue", this.localValue);
      this.$emit("search", this.localValue);
    },
  },
};
</script>
